import { Component, Input, OnInit } from '@angular/core';
import { TrackAndTraceItem } from './track-and-trace-item/track-and-trace-item.component';
import { Transporter } from '../../../../models/transporter.model';
import dayjs, { Dayjs } from 'dayjs';
import { TransportOrderView } from '../../../../models/transport-order-view.model';

@Component({
  selector: 'jhi-track-and-trace',
  templateUrl: './track-and-trace.component.html',
})
export class TrackAndTraceComponent implements OnInit {
  @Input() transportOrder: TransportOrderView | null | undefined;
  @Input() savMail!: string | undefined;

  @Input() transporter!: Transporter;
  trackAndTraceItems: any[] = [];

  ngOnInit(): void {
    this.generateTimelineItems();
  }

  private generateTimelineItems(): void {
    const trackAndTrace1 = new TrackAndTraceItem();
    trackAndTrace1.stepIndex = 1;
    trackAndTrace1.isActive = this.transportOrder?.trackAndTrace?.stepOneActive ?? false;
    trackAndTrace1.isError = this.transportOrder?.trackAndTrace?.errorNumber === trackAndTrace1.stepIndex;
    trackAndTrace1.stepDate = this.getStepDate(this.transportOrder?.trackAndTrace?.stepOneDate);
    trackAndTrace1.messageKey = this.transportOrder?.trackAndTrace?.stepOneKey;
    trackAndTrace1.icon = 'clipboard-check';

    const trackAndTrace2 = new TrackAndTraceItem();
    trackAndTrace2.stepIndex = 2;
    trackAndTrace2.isActive = this.transportOrder?.trackAndTrace?.stepTwoActive ?? false;
    trackAndTrace2.isError = this.transportOrder?.trackAndTrace?.errorNumber === trackAndTrace2.stepIndex;
    trackAndTrace2.stepDate = this.getStepDate(this.transportOrder?.trackAndTrace?.stepTwoDate);
    trackAndTrace2.messageKey = this.transportOrder?.trackAndTrace?.stepTwoKey;
    trackAndTrace2.icon = 'dolly';

    const trackAndTrace3 = new TrackAndTraceItem();
    trackAndTrace3.stepIndex = 3;
    trackAndTrace3.isActive = this.transportOrder?.trackAndTrace?.stepThreeActive ?? false;
    trackAndTrace3.isError = this.transportOrder?.trackAndTrace?.errorNumber === trackAndTrace3.stepIndex;
    trackAndTrace3.stepDate = this.getStepDate(this.transportOrder?.trackAndTrace?.stepThreeDate);
    trackAndTrace3.messageKey = this.transportOrder?.trackAndTrace?.stepThreeKey;
    trackAndTrace3.icon = 'route';

    const trackAndTrace4 = new TrackAndTraceItem();
    trackAndTrace4.stepIndex = 4;
    trackAndTrace4.isActive = this.transportOrder?.trackAndTrace?.stepFourActive ?? false;
    trackAndTrace4.isError = this.transportOrder?.trackAndTrace?.errorNumber === trackAndTrace4.stepIndex;
    trackAndTrace4.stepDate = this.getStepDate(this.transportOrder?.trackAndTrace?.stepFourDate);
    trackAndTrace4.messageKey = this.transportOrder?.trackAndTrace?.stepFourKey;
    trackAndTrace4.icon = 'shipping-fast';

    const trackAndTrace5 = new TrackAndTraceItem();
    trackAndTrace5.stepIndex = 5;
    trackAndTrace5.isActive = this.transportOrder?.trackAndTrace?.stepFiveActive ?? false;
    trackAndTrace5.isError = this.transportOrder?.trackAndTrace?.errorNumber === trackAndTrace5.stepIndex;
    trackAndTrace5.stepDate = this.getStepDate(this.transportOrder?.trackAndTrace?.stepFiveDate);
    trackAndTrace5.messageKey = this.transportOrder?.trackAndTrace?.stepFiveKey;
    trackAndTrace5.icon = 'check-circle';

    this.trackAndTraceItems.push(trackAndTrace1, trackAndTrace2, trackAndTrace3, trackAndTrace4, trackAndTrace5);
  }

  private getStepDate(date: any): Dayjs | undefined {
    if (date) {
      return dayjs(date);
    } else {
      return undefined;
    }
  }
}
